var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCursor = function SvgCursor(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 32.25,
    x2: 86,
    y2: 56.104252,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 10.75,
    x2: 86,
    y2: 160.583496,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 110.1875,
    y1: 10.75,
    x2: 110.1875,
    y2: 160.583496,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 61.8125,
    y1: 10.75,
    x2: 61.8125,
    y2: 160.583496,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 103.103249,
    y1: 10.75,
    x2: 103.103249,
    y2: 160.583496,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 68.899437,
    y1: 10.75,
    x2: 68.899437,
    y2: 160.583496,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 10.75,
    x2: 86,
    y2: 160.583496,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 67.859383,
    x2: 86,
    y2: 107.642441,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9097788"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 28.125 13.210938 C 28.125 14.273438 27.59375 15.210938 26.789062 15.78125 C 26.554688 15.011719 25.84375 14.460938 25 14.460938 C 24.15625 14.460938 23.445312 15.011719 23.210938 15.78125 C 22.40625 15.210938 21.875 14.273438 21.875 13.210938 C 21.875 11.488281 23.273438 10.085938 25 10.085938 C 26.726562 10.085938 28.125 11.488281 28.125 13.210938 Z M 28.125 13.210938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 24.21875 4.6875 L 25.78125 4.6875 L 25.78125 7.8125 L 24.21875 7.8125 Z M 24.21875 4.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 30.46875 12.5 L 33.59375 12.5 L 33.59375 14.0625 L 30.46875 14.0625 Z M 30.46875 12.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 16.40625 12.5 L 19.53125 12.5 L 19.53125 14.0625 L 16.40625 14.0625 Z M 16.40625 12.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 29.417969 9.96875 L 28.316406 8.863281 L 30.523438 6.652344 L 31.628906 7.757812 Z M 29.417969 9.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 20.582031 9.96875 L 18.371094 7.757812 L 19.476562 6.652344 L 21.6875 8.863281 Z M 20.582031 9.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 26.5625 45.3125 L 23.4375 45.3125 C 22.574219 45.3125 21.875 44.613281 21.875 43.75 L 21.875 34.375 L 14.832031 34.375 C 14.277344 34.375 13.777344 34.085938 13.496094 33.605469 C 13.210938 33.113281 13.207031 32.527344 13.488281 32.03125 L 22.992188 15.242188 C 23.410156 14.503906 24.160156 14.0625 25 14.0625 C 25.839844 14.0625 26.589844 14.503906 27.007812 15.238281 L 36.511719 32.03125 C 36.792969 32.527344 36.789062 33.113281 36.503906 33.605469 C 36.222656 34.085938 35.722656 34.375 35.167969 34.375 L 28.125 34.375 L 28.125 43.75 C 28.125 44.613281 27.425781 45.3125 26.5625 45.3125 Z M 25 15.625 C 24.871094 15.625 24.550781 15.664062 24.351562 16.011719 L 14.847656 32.800781 L 23.4375 32.8125 L 23.4375 43.75 L 26.5625 43.75 L 26.5625 32.8125 L 35.167969 32.8125 L 35.832031 32.417969 L 35.152344 32.800781 L 25.648438 16.007812 C 25.449219 15.664062 25.128906 15.625 25 15.625 Z M 25 15.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear7)"
    },
    d: "M 29.90625 30.46875 L 20.09375 30.46875 C 19.496094 30.46875 19.121094 29.820312 19.417969 29.300781 L 24.324219 20.714844 C 24.621094 20.191406 25.378906 20.191406 25.675781 20.714844 L 30.582031 29.300781 C 30.878906 29.820312 30.503906 30.46875 29.90625 30.46875 Z M 29.90625 30.46875 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCursor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cursor.f38785de.svg";
export { ForwardRef as ReactComponent };